export default __webpack_public_path__ + "static/media/gallery-10.01c21393.jpg";